import React, { useEffect, useState, useCallback } from 'react'
import EmailPhone from './EmailPhone/EmailPhone'
import Location from './location/location'
import styles from './styles.module.css'
import bracketsCurly from '../../ExpandedRecordDr6/images/brackets-curly-solid.svg'
import rectangleXmark from '../../ExpandedRecordDr6/images/rectangle-xmark.svg'
import JsonViewModal from '../../viewJson'
import License from './License/License'
import PrimaryEmail from './PrimaryEmail/PrimaryEmail'
import PropertiesOwned from './PropertiesOwned/PropertiesOwned'
import CompactPropertyView from './CompactPropertyView/CompactPropertyView'
import useStore from '../../StorePeople/Store'
import BaseAlert from '../../Snackbar/NewImplementations/BaseAlert/BaseAlert'
import { useHistory } from 'react-router-dom'
import { useMutation } from 'react-query'
import { postProperty } from '../../../Api/index'
import useEscapeKey from '../../utils/useEscapeKey'

function ExpandedRecordsPeople ({
  recordData,
  onClose,
  isLoadingRecord,
  isPropertyFunctionality,
  errorNotEnoughCredits,
  setErrorNotEnoughCredits,
  snackBarStateError
}) {
  const { setShouldRefetch } = useStore()
  const [isVisible, setIsVisible] = useState(false)
  const [isJsonModalVisible, setIsJsonModalVisible] = useState(false)
  const toggleJsonModal = () => {
    setIsJsonModalVisible(true)
  }
  const history = useHistory()
  const [record, setRecord] = useState(recordData)

  // R33: Property modal state
  const [showPropertyModal, setShowPropertyModal] = useState(false)
  const [isQueryLoadingProperty, setIsQueryLoadingProperty] = useState(false)
  const [propertyRecord, setPropertyRecord] = useState(null)

  const [errorAlert, setErrorAlert] = useState({
    open: false,
    title: '',
    body: '',
    color: ''
  })

  useEffect(() => {
    // if (isLoadingRecord) return
    if (record || isLoadingRecord) {
      const timeoutId = setTimeout(() => {
        setIsVisible(true)
      }, 1)
      return () => clearTimeout(timeoutId)
    }
  }, [record, isLoadingRecord])

  const handleClose = () => {
    if (!isJsonModalVisible) {
      setIsVisible(false)
      setTimeout(() => {
        onClose()
      }, 250) // Adjust to match your CSS transition duration
    }
  }

  useEscapeKey(handleClose)

  useEffect(() => {
    setRecord(recordData)
    setShouldRefetch(true)
  }, [recordData, setShouldRefetch])

  useEffect(() => {
    if (snackBarStateError) {
      setErrorAlert({
        open: true,
        title: 'Requesting too many records',
        body: "The number of records you're requesting exceeds the available records remaining on your plan. Try narrowing your search or upgrade your account for more record credits.",
        color: '#000000'
      })
    }
    if (errorNotEnoughCredits) {
      setErrorNotEnoughCredits(false)
    }
  }, [snackBarStateError, errorNotEnoughCredits, setErrorNotEnoughCredits])

  // R33: Property API mutation
  const [searchPropertyByKey] = useMutation(
    (queryData) => postProperty(queryData),
    {
      onMutate: () => {
        setIsQueryLoadingProperty(true)
      },
      onSuccess: (data) => {
        // Check if records array exists and has data
        const record = data?.data?.records?.[0] || null
        setPropertyRecord(record)
        setShowPropertyModal(true)
      },
      onError: (error) => {
        console.error('Error fetching property data:', error)
        // Still show modal with null record to display "No Records Found"
        setPropertyRecord(null)
        setShowPropertyModal(true)
      },
      onSettled: () => {
        setIsQueryLoadingProperty(false)
      }
    }
  )

  // R33: Open property modal handler
  const openPropertyModal = useCallback((propertyKey) => {
    searchPropertyByKey({ query: `keys:"${propertyKey}"`, view: 'property_sourceURLs' })
  }, [searchPropertyByKey])

  // R33: Close property modal handler
  const closePropertyModal = useCallback(() => {
    setShowPropertyModal(false)
    setPropertyRecord(null)
  }, [])

  // Display a loading modal if details are still being fetched
  if (isLoadingRecord || !record) {
    return (
      <div className={styles.modalBackdropExpandedRecord} onClick={handleClose}>
        <div
          className={styles.modalContentExpandedRecord}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transform: isVisible ? 'translateX(0)' : 'translateX(100%)',
            width: isPropertyFunctionality === true ? '650px' : '800px'
          }}
          onClick={e => e.stopPropagation()}
        >
          <p>Loading details...</p> {/* Show loading text or spinner */}
        </div>

        <BaseAlert
          open={errorAlert.open}
          title={errorAlert.title}
          body={errorAlert.body}
          color={errorAlert.color}
          actions={[
            {
              label: 'Upgrade account',
              onClick: () => history.push('/settings/billing/subscription')
            },
            {
              label: 'Ok',
              onClick: () => setErrorAlert(prev => ({ ...prev, open: false }))
            }
          ]}
          onClose={() => setErrorAlert(prev => ({ ...prev, open: false }))}
          style={{ width: '320px' }}
        />
      </div>
    )
  }

  return (
    <div onClick={e => e.stopPropagation()}>
      <div className={styles.modalBackdropExpandedRecord} onClick={handleClose}>
        <div
          className={styles.modalContentExpandedRecord}
          style={{
            transform: isVisible ? 'translateX(0)' : 'translateX(100%)',
            width: isPropertyFunctionality === true ? '700px' : '800px'
          }}
          onClick={e => e.stopPropagation()}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginBottom: '4px'
            }}
          >
            <h1 className={styles.titleExpandedRecordPeople}>
              {record.firstName || 'N/A'} {record.lastName || 'N/A'}
            </h1>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <div
                style={{ display: 'flex', cursor: 'pointer' }}
                onClick={handleClose}
              >
                <span className={styles.buttonClose}>Close</span>
                <img
                  alt='rectangleXmarkIcon'
                  onClick={handleClose}
                  src={rectangleXmark}
                  className={styles.rectangleIcon}
                />
              </div>
              <div
                className={styles.containerViewJson}
                onClick={toggleJsonModal}
              >
                <span className={styles.buttonJsonView}>View JSON</span>
                <img
                  alt='bracketsCurly'
                  src={bracketsCurly}
                  style={{ width: '14px' }}
                />
              </div>
            </div>
          </div>
          <div>
            <h2 className={styles.jobTitleExpandedRecord}>
              {record?.jobTitle && record?.businessName
                ? `${record.jobTitle} at ${record.businessName}`
                : record?.jobTitle
                ? record.jobTitle
                : record?.businessName
                ? record.businessName
                : 'N/A'}
            </h2>
          </div>
          <Location record={record} />
          <PrimaryEmail record={record} />
          <hr className={styles.hrStyles} />
          <EmailPhone record={record} />
          <hr className={styles.hrStyles} />
          <section style={{ display: 'flex' }}>
            <License record={record} />
          </section>
          <hr className={styles.hrStyles} />
          {/* R33: Properties Owned section */}
          <PropertiesOwned record={record} onPropertyClick={openPropertyModal} />
        </div>
      </div>
      {/* R33: Compact Property modal */}
      {showPropertyModal && (
        <CompactPropertyView
          record={propertyRecord}
          onClose={closePropertyModal}
          isLoadingRecord={isQueryLoadingProperty}
        />
      )}
      {isJsonModalVisible && (
        <JsonViewModal
          jsonData={record}
          onClose={() => setIsJsonModalVisible(false)}
          isPropertyFunctionality={isPropertyFunctionality}
        />
      )}
    </div>
  )
}

export default ExpandedRecordsPeople
